import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  padding: 5rem 2rem 3rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const FooterLinks = styled.ul`
  list-style: none; padding: 0;
  li { margin-bottom: 1rem; }
  a { color: rgba(255, 255, 255, 0.8); text-decoration: none; }
  a:hover { color: white; }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <div style={{gridColumn: 'span 1'}}>
          <img src="/images/logo.png" alt="Logo" height="60" />
          <p style={{marginTop: '1rem', opacity: 0.8}}>Professional care and agency staffing across the West Midlands.</p>
        </div>
        <div>
          <h3>Our Services</h3>
          <FooterLinks>
            <li><Link to="/services/agency-staffing">Agency Staffing</Link></li>
            <li><Link to="/services/dementia-care">Dementia Care</Link></li>
            <li><Link to="/services/live-in-care">Live-In Care</Link></li>
          </FooterLinks>
        </div>
        <div>
          <h3>Quick Links</h3>
          <FooterLinks>
            <li><Link to="/work-with-us" style={{fontWeight: 'bold'}}>Work With Us</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/testimonials">Testimonials</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </FooterLinks>
        </div>
        <div>
          <h3>Contact</h3>
          <p>1-3 Market Place, Willenhall, WV13 2AA</p>
          <p>+44 7874 290538</p>
          <p>enquiries@ljagapehc.co.uk</p>
        </div>
      </FooterContent>
      <div style={{ textAlign: 'center', marginTop: '3rem', opacity: 0.5 }}>
        &copy; {new Date().getFullYear()} L&J Agape Healthcare Ltd.
      </div>
    </FooterContainer>
  );
};

export default Footer;
